/**
 * getNextPageParam for React Query infinite queries backed by offset pagination.
 * Returns the next offset (current offset + items on the last page) while
 * `hasMore` is true, otherwise undefined to stop fetching.
 */
export function getOffsetPageParam(
  lastPage: { items: unknown[]; hasMore: boolean },
  _allPages: unknown,
  lastPageParam: unknown
): number | undefined {
  if (!lastPage.hasMore) {
    return undefined;
  }
  return (lastPageParam as number) + lastPage.items.length;
}
